/* ========================================================================== *\
    Components
/* ========================================================================== */
import './5-components/autoplay';
import './5-components/detail-popup';
import './5-components/filter';
import './5-components/filter-container';
import './5-components/filter-dialog';
import './5-components/info-box';
import './5-components/list';
import './5-components/markers';
import './5-components/map';
import './5-components/paging';
import './5-components/range';
import './5-components/search';
import './5-components/sidebar';
import './5-components/year';

// import './2-utilities/store';

/* ========================================================================== *\
    Help functionality
/* ========================================================================== */
const helpMsg = document.querySelector('.js-help');

//first show the help box
setTimeout(() => {
    helpMsg.classList.remove('--hide');
    helpMsg.classList.add('--show');
}, 6000);

//then hide it again
setTimeout(() => {
    helpMsg.classList.remove('--show');
    helpMsg.classList.add('--hide');

    setTimeout(() => {
        helpMsg.parentNode.removeChild(helpMsg);
    }, 2000)
}, 6000 + 3000);
